import SocialSecurityArrearTable from 'lib/common/Tables/SocialSecurityArrearTable';
import { SocialSecurityArrear } from 'lib/types/models';
import React from 'react';

function SocialSecurityArrearResponse({
  arrears,
}: {
  arrears: SocialSecurityArrear[];
}) {
  return <SocialSecurityArrearTable arrears={arrears} />;
}

export default SocialSecurityArrearResponse;
